import React from 'react';

const Chapter6Content = () => {
  return (
    <article className="prose prose-lg max-w-none">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Chapter Six</h1>
        <p className="text-xl text-gray-600">The Verdict</p>
        <p className="text-lg text-gray-500 mt-2">Step Back and See the Picture</p>
      </div>

      <div className="mb-12">
        <p className="text-gray-800 leading-relaxed mb-4">
          The corners are in place. The frame is well built. The borders are locked. Now step back from the table and look at what has been assembled.
        </p>
        <p className="text-gray-800 leading-relaxed mb-4">
          <strong>What do you see?</strong>
        </p>
      </div>

      <div className="mb-12">
        <p className="text-gray-800 leading-relaxed mb-4">
          You see the timeline of the end of the age, drawn not by any human tradition but by the grammar of God's own Word.
        </p>
        <p className="text-gray-800 leading-relaxed mb-4">
          The great rebellion comes. The man of lawlessness is revealed — he sits in the temple and declares himself God. The tribulation begins. Across the whole world, people choose. The saints endure. The overcomers overcome. By the blood of the Lamb and the word of their testimony, they face the darkness and do not shrink back.
        </p>
        <p className="text-gray-800 leading-relaxed mb-4">
          And then — at the moment the last trumpet sounds, at the moment the final bowl of God's wrath is poured out on the wicked, at the moment the armies of the world converge on a valley called Armageddon — the sky breaks open.
        </p>
      </div>

      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-300 rounded-lg p-8 my-12">
        <p className="text-lg text-gray-900 leading-relaxed mb-4">
          The Son of Man appears. Not secretly. Not quietly. <strong>Every eye sees Him.</strong>
        </p>
        <p className="text-lg text-gray-900 leading-relaxed mb-4">
          The angels sweep from one end of heaven to the other, and they gather the elect — the blood-bought, the faithful, the enduring — from every corner of the earth and heaven.
        </p>
        <p className="text-lg text-gray-900 leading-relaxed mb-4">
          The last trumpet blasts — the great <strong>Tekiah Gedolah</strong> that God rehearsed with His people for millennia — and it rings across the universe.
        </p>
        <p className="text-lg text-gray-900 leading-relaxed mb-4">
          The dead in Christ rise first. The living are caught up together with them, to meet the Lord in the air. And together — the returning King and His royal escort — they come back down.
        </p>
        <p className="text-lg text-gray-900 leading-relaxed">
          The Antichrist is destroyed by the brightness of His coming. Death loses its sting. The first resurrection is complete. The victory is total.
        </p>
      </div>

      <div className="text-center my-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">
          This is the picture the puzzle was always showing.
        </h2>
        <p className="text-xl text-gray-700 mb-4">
          It has always been there.
        </p>
        <p className="text-xl text-gray-700 mb-4">
          The treasure map just needed rightly divided attention to detail.
        </p>
        <p className="text-xl text-gray-700">
          The legend was always in the corner. We just needed to look for it.
        </p>
      </div>

      <div className="bg-green-50 border-2 border-green-500 rounded-lg p-8 text-center my-12">
        <p className="text-2xl font-bold text-green-900 mb-4">
          Grandmother no longer feels like a helpless evacuee.
        </p>
        <p className="text-xl text-green-800">
          She knows the sound of the Tekiah Gedolah — and she knows she is part of the Kingdom Escort Guard. The great wedding party escort of the Bridegroom. The Returning King.
        </p>
      </div>

      <div className="flex justify-center gap-4 my-8">
        <span className="text-2xl text-amber-600">✦</span>
        <span className="text-2xl text-amber-600">✦</span>
        <span className="text-2xl text-amber-600">✦</span>
      </div>
    </article>
  );
};

export default Chapter6Content;